/**
 * Produktkategorien — Single Source of Truth für Dropdowns.
 *
 * Verwendet in `Produkte` (Anlegen/Bearbeiten + Filter). Bestehende
 * Produkte behalten ihre Freitext-Kategorie, bis sie explizit editiert
 * werden — der Wert wird im Formular als „Sonstiges" vorgewählt und die
 * Kategorie-Spalte in der Tabelle zeigt weiterhin den Originalwert.
 */
export const PRODUCT_CATEGORIES = [
  "Getränke",
  "Nahrung / Snacks",
  "E-Zigaretten / Vape",
  "Tabakwaren",
  "Hygiene / Drogerie",
  "Non-Food",
  "Sonstiges",
];

export const PRODUCT_CATEGORY_SET = new Set(PRODUCT_CATEGORIES);
